// extracted by mini-css-extract-plugin
export var component = "ParagraphMediaEnquiryGroup-module--component--f9182";
export var contactList = "ParagraphMediaEnquiryGroup-module--contactList--96b36";
export var fadePop = "ParagraphMediaEnquiryGroup-module--fade-pop--7e0d0";
export var field_email_address = "ParagraphMediaEnquiryGroup-module--field_email_address--99804";
export var field_job_title = "ParagraphMediaEnquiryGroup-module--field_job_title--92f58";
export var field_phone_number = "ParagraphMediaEnquiryGroup-module--field_phone_number--63b9e";
export var field_title = "ParagraphMediaEnquiryGroup-module--field_title--f898e";
export var growHeightIn = "ParagraphMediaEnquiryGroup-module--grow-height-in--4c5d2";